<template>
  <div class="UIInputError">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.UIInputError {
  @include font-size-10px;
  color: $color-error-40;
  margin-top: 0.25rem;
}
</style>
